import { render } from "./searchMore.vue?vue&type=template&id=ef03e99e&scoped=true"
import script from "./searchMore.vue?vue&type=script&lang=js"
export * from "./searchMore.vue?vue&type=script&lang=js"

import "./searchMore.vue?vue&type=style&index=0&id=ef03e99e&lang=less&scoped=true"

import exportComponent from "D:\\workspace\\zh-frontend\\microfront-main\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef03e99e"]])

export default __exports__